import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

const NotFound = () => {
  return (
    <>
      <SEO title="Stranica nije pronađena | RB TIM" description="Tražena stranica ne postoji." />
      <section className="section" data-testid="not-found">
        <div className="container-rb" style={{ textAlign: "center", padding: "40px 0" }}>
          <span className="eyebrow">404</span>
          <h1 style={{ marginTop: 8 }}>Stranica nije pronađena</h1>
          <p className="section-lead" style={{ marginLeft: "auto", marginRight: "auto" }}>
            Stranica koju tražite ne postoji ili je premestena.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: 12, flexWrap: "wrap" }}>
            <Link to="/" className="btn btn-primary">Početna</Link>
            <Link to="/modeli-kontejnera" className="btn btn-outline">Modeli kontejnera</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default NotFound;
